import React from 'react';
import { FiGrid, FiList, FiImage } from 'react-icons/fi';
import './ViewToggle.css';

const ViewToggle = ({ activeView, onViewChange }) => {
  const views = [
    { id: 'card', icon: <FiGrid />, label: 'Tarjetas' },
    { id: 'list', icon: <FiList />, label: 'Lista' },
    { id: 'gallery', icon: <FiImage />, label: 'Galería' }
  ];

  return (
    <div className="view-toggle">
      {views.map(view => (
        <button
          key={view.id}
          className={`view-btn ${activeView === view.id ? 'active' : ''}`}
          onClick={() => onViewChange(view.id)}
          title={view.label}
        >
          {view.icon}
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
